<template>
  <v-row justify="center">
    <v-col cols="12">
      <m-breadcrum :items="bread"></m-breadcrum>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-text
          ><v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="modul"
                :items="listModul"
                label="Paket Modul"
                name="Peran"
                item-value="id"
                item-text="nama"
                return-object
                @change="loadJadwal"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-expansion-panels v-model="panel">
        <v-expansion-panel v-for="(kelas, i) in jadwals" :key="i">
          <v-expansion-panel-header class="header title grey lighten-3 primary--text"
            >Detail Aktivitas
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ListModul
              class="mt-4"
              :tipe="3"
              :kelas="kelas.keterangan"
              addData
              :items="kelas.submateri"
              @load="loadJadwal"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
import { ALERT_INFO } from "@/const";
import ChangeDlg from "../../diklat/components/Form.vue";
import ListModul from "../../diklat/components/ListModul.vue";

export default {
  components: {
    ChangeDlg,
    ListModul
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      jadwals: [],
      page: null,
      panel: 0,
      paneljadwal: 0,
      cp: 1,
      itemModuls: [],
      modul: null,
      listModul: []
    };
  },

  activated() {
    this.loadJadwal();
    this.paneljadwal = 0;
  },

  mounted() {
    this.loadJadwal();
    this.paneljadwal = 0;
  },

  methods: {
    loadJadwal() {
      return this.$store
        .dispatch("diklat/getJadwalsTs", {
          instansi_id: this.instansi_id,
          kelas_id: this.$route.params.kelas_id
        })
        .then(res => {
          this.listModul = res;
          if (!this.modul) {
            this.modul = this.listModul[0];
            this.jadwals = res.filter(r => r.id == this.modul.id);
          } else {
            this.jadwals = res.filter(r => r.id == this.modul.id);
          }
        })
        .catch(e => e);
    },
    toCourse(val) {
      window.open(val.link_moodle, "_blank");
    },
    toTimespent(obj) {
      this.$refs.timespentDlg.open(obj);
    }
  },

  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },

    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Daftar Kelas",
          to: { name: "diklatku", params: { instansi_id: this.instansi_id } }
        },
        {
          icon: "mdi-edit",
          title: this.$route.params.nama_kelas
        }
      ];
    }
  }
};
</script>
